import React, { useState, useEffect, useRef, useCallback, useContext } from "react"
import { Switch, Route, useLocation, Redirect } from "react-router-dom"
import { CircularProgress } from "@material-ui/core"
import useStyles from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx"
import Navbar from "components/Navbar.jsx"
import Sidebar from "components/Sidebar.jsx"
import SandDriveBanner from "components/SandDriveBanner.jsx"
import routes from "routes.js"
import { queries } from "queries"
import { useGqlDirect } from "helpers"
import { actionGenerators } from "reducer"
import { ReducerContext } from "App"
import axios from 'axios'
import { useConfig } from 'hooks/useConfig'

const Home = () => {
  const { dispatch, state: { reset } } = useContext(ReducerContext)
  const location = useLocation()
  const mainPanelRef = useRef(null)
  const { wrapper, mainPanel, content, container } = useStyles()
  const [mobileOpen, setMobileOpen] = useState(false)
  const [sandDriveConfig, setSandDriveConfig] = useState(null)
  const { config } = useConfig()
  const toggle = () => setMobileOpen(!mobileOpen)
  useEffect(() => { if (mainPanelRef.current) mainPanelRef.current.scrollTop = 0 }, [location])
  
  // Function to refresh SandDrive config
  // Stable identity via useCallback: this is passed down to SandDriveBanner as an effect
  // dependency, so a new reference on every render would re-trigger that effect in a loop
  const refreshSandDriveConfig = useCallback(() => {
    const apiUrl = config.LOGITRAC_API_URL || localStorage.getItem('LOGITRAC_API_URL')
    if (apiUrl) {
      axios
        .get(`${apiUrl}api/config/sanddrive-review-app`)
        .then(response => {
          setSandDriveConfig(response.data)
        })
        .catch(error => {
          console.error('Failed to fetch SandDrive config:', error)
        })
    }
  }, [config])

  const { data: constants } = useGqlDirect(queries.GET_ACTIVE_CONST)
  const { data: allUsers } = useGqlDirect(queries.GET_ALL_USERS)

  useEffect(() => {
    if (constants && allUsers) {
      dispatch(actionGenerators.init({ constants, allUsers, reset: false }))
    }
  }, [constants, allUsers, dispatch])

  return <>
    {reset ? <CircularProgress /> :
      <>
        <SandDriveBanner sandDriveConfig={sandDriveConfig} refreshConfig={refreshSandDriveConfig} />
        <div className={wrapper}>
          <Sidebar
            routes={routes.filter(route => route.path !== "/unauthorized")}
            toggle={toggle}
            open={mobileOpen}
          />
          <div className={mainPanel} ref={mainPanelRef}>
            <Navbar toggle={toggle} />
            <div className={content}>
              <div className={container}>
                <Switch>
                  {routes.map((route, key) => (
                    <Route exact={route.path === "/"} path={route.path} key={key}>
                      {React.cloneElement(route.component, { onSandDriveConfigUpdate: refreshSandDriveConfig })}
                    </Route>
                  ))}
                  <Redirect from="/" to="/outbound" />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </>
    }</>
}

export default Home
